import { el } from '../lib/dom.js';

/**
 * Modal genérico com teclado (Enter confirma, Esc fecha), foco automático e
 * proteção contra duplo envio (botões viram "Salvando…" e o fundo não fecha).
 * onClick pode ser async; retornar `false` mantém o modal aberto (validação/erro).
 */
export function abrirModal({ titulo, corpo, acoes = [], classe = '' }) {
  const fundo = el('div', { class: 'modal-bg' });
  let enviando = false;
  const fechar = () => { if (!enviando) fundo.remove(); };

  const botoes = [];
  const rodape = el('div', { class: 'modal__foot' },
    acoes.map((a) => {
      const btn = el('button', { class: a.classe || 'btn' }, a.rotulo);
      botoes.push(btn);
      btn.addEventListener('click', async () => {
        if (enviando) return;
        if (a.onClick) {
          enviando = true;
          botoes.forEach((b) => (b.disabled = true));
          btn.innerHTML = '<i class="ph ph-circle-notch ph-spin"></i> Salvando…';
        }
        let r;
        try { r = await a.onClick?.(); }
        finally { enviando = false; }
        if (a.fechar !== false && r !== false) {
          fundo.remove();
        } else if (a.onClick) {
          botoes.forEach((b) => (b.disabled = false));
          btn.textContent = a.rotulo;
        }
      });
      return btn;
    }),
  );

  const modal = el('div', { class: 'modal' + (classe ? ' ' + classe : '') }, [
    el('div', { class: 'modal__head' }, [
      el('h3', { text: titulo }),
      el('button', { class: 'modal__x', onClick: fechar, html: '&times;' }),
    ]),
    el('div', { class: 'modal__body' }, [].concat(corpo)),
    acoes.length ? rodape : null,
  ]);

  fundo.append(modal);
  // Fecha ao clicar no fundo (backdrop) SO se nada foi digitado (preserva dados). Tambem fecha por X/Cancelar/acao/Esc.
  fundo.addEventListener('mousedown', (e) => {
    if (e.target !== fundo || enviando) return;
    const sujo = Array.from(modal.querySelectorAll('input, textarea')).some((c) => {
      if (c.type === 'checkbox' || c.type === 'radio') return c.checked !== c.defaultChecked;
      return (c.value || '') !== (c.defaultValue || '');
    });
    if (!sujo) fundo.remove();
  });

  const idxPrim = acoes.findIndex((a) => /primario/.test(a.classe || ''));
  const btnPrim = botoes[idxPrim] || botoes[botoes.length - 1];

  fundo.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); fechar(); }
    else if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && !enviando) {
      e.preventDefault();
      btnPrim?.click();
    }
  });

  document.body.append(fundo);
  const foco = modal.querySelector('input, select') || btnPrim;
  requestAnimationFrame(() => foco?.focus());

  return { fechar, el: modal };
}

